import { createContext, useContext, useState } from "react";
import MessageModal from "../components/MessageModal";

const ModalContext = createContext();

export const useModal = () => useContext(ModalContext);

export const ModalProvider = ({ children }) => {
  const [afterCloseCallback, setAfterCloseCallback] = useState(null);
  const [onConfirm, setOnConfirm] = useState(null);
  const [confirmOnly, setConfirmOnly] = useState(false);
  const [modal, setModal] = useState({
    open: false,
    title: "",
    message: "",
  });

  const showModal = (
    title,
    message,
    onConfirmFn = null,
    onCloseNext = null
  ) => {
    setModal({ open: true, title, message });
    setAfterCloseCallback(() => onCloseNext);
    setOnConfirm(() => onConfirmFn);
    setConfirmOnly(!!onConfirmFn); // true if confirm is passed
  };
  const closeModal = () => {
    setModal((prev) => ({ ...prev, open: false }));

    if (typeof afterCloseCallback === "function") {
      afterCloseCallback();
    }

    setAfterCloseCallback(null);
    setOnConfirm(null); // ✅ Reset after closing
    setConfirmOnly(false);
  };

  return (
    <ModalContext.Provider value={{ showModal, closeModal }}>
      {children}
      <MessageModal
        open={modal.open}
        title={modal.title}
        message={modal.message}
        confirmOnly={confirmOnly}
        onConfirm={onConfirm}
        onClose={closeModal}
      />
    </ModalContext.Provider>
  );
};
